<template>
  <div :id='id' class="rateChart">
  </div>
</template>

<script>
  import * as echarts from 'echarts';

export default {
    name: 'rateChart',
    components: {
    },
    props: {
        chartData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            id: this.chartData.id,
            textColor: this.chartData.textColor,
            backgroundColor: this.chartData.backgroundColor,
            startColor: this.chartData.startColor,
            endColor: this.chartData.endColor,
            textContent: this.chartData.textContent,
            centergroundColor: this.chartData.centergroundColor,
            myChart: null,
            option: null,
        };
    },
    watch: {
        chartData: {
            handler(newVal) {
                this.initOptions(newVal);
                this.myChart.setOption(this.option);
            },
            deep: true,
        },
    },
    methods: {
        refresh() {
            this.myChart.setOption(this.option);
        },
        initOptions(data) {
            this.option = {
                backgroundColor: '#ffffff',
                title: {
                    text: `${data.textContent}%`,
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        color: data.textColor,
                        fontSize: 20,
                        fontWeight: 'normal',
                    },
                },
                angleAxis: {
                    max: 100,
                    clockwise: false,
                    // 隐藏刻度线
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                },
                radiusAxis: {
                    type: 'category',
                    // 隐藏刻度线
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                },
                polar: {
                    center: ['50%', '50%'],
                    radius: '135%', // 图形大小
                },
                series: [
                    {
                        name: 'background',
                        type: 'pie',
                        label: false,
                        radius: [0, 40],
                        center: ['50%', '50%'],
                        data: [
                            {
                                value: 100,
                                itemStyle: {
                                    color: data.centergroundColor,
                                },
                            },
                        ],
                    },
                    {
                        type: 'bar',
                        data: [
                            {
                                name: 'showpart',
                                value: data.textContent,
                                itemStyle: {
                                    normal: {
                                        color: new echarts.graphic.LinearGradient(0, 0, 1, 1, [
                                            {
                                                offset: 0,
                                                color: data.startColor,
                                            }, {
                                                offset: 1,
                                                color: data.endColor,
                                            }]),
                                    },
                                },
                            }],
                        coordinateSystem: 'polar',
                        roundCap: true,
                        barWidth: 25,
                        barGap: '-100%', // 两环重叠
                        z: 2,
                    },
                    { // 灰色环
                        type: 'bar',
                        data: [{
                            value: 100,
                            itemStyle: {
                                color: data.backgroundColor,
                                shadowColor: 'rgba(0, 0, 0, 0.2)',
                                shadowBlur: 5,
                                shadowOffsetY: 2,
                            },
                        }],
                        coordinateSystem: 'polar',
                        roundCap: true,
                        barWidth: 25,
                        barGap: '-100%', // 两环重叠
                        z: 1,
                    },
                ],
            };
        },
    },
    mounted() {
        this.myChart = echarts.init(document.getElementById(this.chartData.id));
        this.initOptions(this.chartData);
        this.myChart.setOption(this.option);
    },
};
</script>

<style scoped lang='stylus' rel='stylesheet/stylus'>
  @import '~common/stylus/variable'
  @import '~common/stylus/mixin'
  .rateChart
    height 100%
    width 100%
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/myapp/app-rate-chart.vue